import { render, staticRenderFns } from "./tz.vue?vue&type=template&id=172806a1&scoped=true&"
import script from "./tz.vue?vue&type=script&lang=js&"
export * from "./tz.vue?vue&type=script&lang=js&"
import style0 from "./tz.vue?vue&type=style&index=0&id=172806a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172806a1",
  null
  
)

export default component.exports